<div class="py-3 flex flex-column align-items-start justify-content-start">
    <div>
        Pour accéder à cette fonctionnalité, découvrez nos forfaits adaptées à vos besoins.
    </div>

    <div class="w-full mt-5 flex align-items-center justify-content-end">
        <p-button type="button" label="En savoir plus" icon="pi pi-arrow-right" iconPos="right"
            [rounded]="true"
            (click)="onClickGoToSubscriptions()"></p-button>
        </div>
</div>